import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { buildEdgeAuthStartUrl } from '@cortex/core-types';
import { authApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business aC Men's Hub の認証フック。現在ユーザー取得・Google OAuth ログイン開始・ログアウトを提供する。
 * @graph-connects authApi [calls] Auth API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useAuth() {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.auth.current,
    queryFn: authApi.getCurrentUser,
    staleTime: 5 * 60_000,
    retry: false,
  });

  const loginMutation = useMutation({
    mutationFn: () => {
      window.location.href = buildEdgeAuthStartUrl(window.location.href);
      return Promise.resolve();
    },
  });

  const logoutMutation = useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      queryClient.setQueryData(queryKeys.auth.current, null);
      window.location.href = '/login';
    },
  });

  const user = data?.user ?? null;

  return {
    user,
    expiresAt: data?.expiresAt,
    isAuthenticated: !!user,
    isLoading,
    error,
    refetch,
    login: loginMutation.mutate,
    logout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
  };
}
